import type { IStyleFunctionOrObject } from '@fluentui/react';
import type { ICollapsibleStyle, ICollapsibleStyleProps } from '@m365-admin/collapsible';

export function getCollapsibleStyles(
  props: ICollapsibleStyleProps,
): IStyleFunctionOrObject<ICollapsibleStyleProps, ICollapsibleStyle> {
  const { theme } = props;
  const { effects } = theme;

  const styles: Partial<ICollapsibleStyle> = {
    root: {
      borderTop: 'unset',
      '::before': [
        {
          backgroundColor: theme.palette?.neutralQuaternaryAlt,
          height: '2px',
          display: 'flex',
          borderRadius: effects?.roundedCorner2,
          content: '""',
        },
      ],
    },
  };

  return styles;
}
